export default "__VITE_ASSET__D4r9D0q1__"